module.exports = __webpack_public_path__ + "img/style_1.de2e6ec8.png";